import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Lottie from "lottie-react";
import missionImg from "./mission.json";
import style from "./prtpMission.module.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useMediaQuery } from "@mui/material";

const PRTPMission = () => {
  const [secondary, setSecondary] = React.useState(false);
  React.useEffect(() => {
    AOS.init();
  }, []);

  const matches = useMediaQuery("(max-width:768px)");

  return (
    <Container>
      <Row className="justify-content-center align-items-center">
        <Col md={6} xs={12}>
          <Typography
            sx={{ mt: 4 }}
            fontWeight={600}
            variant={matches ? "h5" : "h4"}
            component="div"
          >
            The <span className="text-danger">Mission </span>of{" "}
            <span className="text-primary">PRTP</span>
          </Typography>

          <List>
            {Missions.map((mission, idx) => (
              <ListItem key={idx} data-aos="fade-up">
                <CheckCircleIcon color="primary" sx={{ fontSize: "26px" }} />
                <ListItemText
                  className="mx-2"
                  primary={mission.mis}
                  secondary={secondary ? "Secondary text" : null}
                />
              </ListItem>
            ))}
          </List>
        </Col>
        <Col md={6} xs={12}>
          <Lottie
            className={`${style.animSize}`}
            animationData={missionImg}
            loop={true}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default PRTPMission;

const Missions = [
  {
    mis: "Make case accessibility of research learning from skilled and experienced research experts.",
  },
  {
    mis: "Enhance research activities among the people.",
  },
  {
    mis: "Convert research outcome into usable benefits by the people.",
  },
  {
    mis: "Build up a trusted between bridge a research expert and a research learner",
  },
];
